module.exports = __webpack_public_path__ + "static/media/404Safari.cbaa0b57.png";